// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n/i18n';
import messages from './i18n/langs/languages'


// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

Vue.use(ElementUI);

function isEmptyObject(e){
  let t;
  for (t in e)
    return !1;
  return !0
}

// 无资源文件时报错问题
try{
	for (let key of Object.keys(language)) {
    if(isEmptyObject(language[key])){
      messages[key].list = language.enUS;
    }else{
      messages[key].list = language[key];
    }
  }
}catch(e){
	// console.log(e.message);//sojson is undefined
}

// 自定义共同方法(this，MessgeName,type类型)
Vue.prototype.PublicMsg = function (that,msg,msgType){
  if(msg!=undefined){
    if(that.$t('list.'+msg).indexOf("list.") != -1){
      that.$message({
        message: msg,
        duration:6000,
        type: msgType
      });
    }else{
      that.$message({
        message: that.$t('list.'+msg),
        duration:6000,
        type: msgType
      });
    }
  }
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js